import {
  SET_TAB_MANAGEMENT,
  ACTIVATE_DESACTIVATE_ACCOUNT,
} from "../types/tabManagementTypes";

const initialState = {
  all: [],
  enterprises: [],
  types: [],
  totalPages: 0,
  creditTiers: {},
};

const tabManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TAB_MANAGEMENT:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        enterprises: action.payload.enterprises,
        types: action.payload.types,
        creditTiers: action.payload.creditTiers || {},
      };
    case ACTIVATE_DESACTIVATE_ACCOUNT:
      return {
        ...state,
        all: state.all.map((item) =>
          item.public_id === action.payload.userPublicId
            ? { ...item, status: action.payload.status }
            : item
        ),
      };
    default:
      return state;
  }
};

export default tabManagementReducer;